define('viewmodels/ActionTracker/ActionTracking',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils', 'services/AppRoutes', 'viewmodels/GeneralSettings', 'viewmodels/header'],
    function (ko, router, app, appsecurity, navigation, system, logger, utils, AppRoutes, ObjGeneralSettings, header) {
    var ActionTrackingVM = {
        title: ko.observable("Action Tracking"),
        attached: attached,
        activate: activate,
        appsecurity: appsecurity,
        router: router,
        logger: logger,
        utils: utils,
        ActionTrackingList: ko.observableArray(),
        ActionPlanTrackingList: ko.observableArray(),
        GetATMetrics: GetATMetrics,
        GetPlanATMetrics: GetPlanATMetrics,
        ATMetricsList: ko.observableArray(),
        OverallMetrics: ko.observableArray(),
        ViewActionItemDetails: ViewActionItemDetails,
        SendActionItemNotification: SendActionItemNotification,
        ResponseMoveArray: ko.observableArray([]),
        ClickedSurveyPoints: ko.observableArray([]),
        DownloadActionItemStatus: DownloadActionItemStatus,
        DownloadActionDetail: DownloadActionDetail,
        ActionStatusTabClick: ActionStatusTabClick,
     //   FiltersForGraphs: FiltersForGraphs,
        ActionItemVisible: ko.observable(true)
    };
    var RaTableObj;
    return ActionTrackingVM;

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionTracking.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            $('#ActionTrackingTab').tabs();
            $('#ActionTrackingTab').tabs('refresh');
            $('#LoadingImgMain').show();
            $('#tblActionTracking').hide();
            GetAllActionItems();
            GetATMetrics();
            $('#ActionItemTab1').addClass('active');
            //$('#ActionItemTab').trigger('click');
            
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | attached() in ActionTracking.js';
            logger.logMessage(msg);
        }
    };
    function ActionStatusTabClick(data,event) {
        try {
         
            $('#LoadingImgMain').show();
            $('#tblActionTracking').hide();
            dtable = $("#tblActionTracking").DataTable();
            dtable.destroy();
            $("#tblActionTracking tbody tr").remove();
            dtable = $("#tblActionPlanTracking").DataTable();
            dtable.destroy();
            $("#tblActionPlanTracking tbody tr").remove();
            $('#ActionTrackTabs li').removeClass('active');
            $('#' + event.currentTarget.id).addClass('active');
            if (event.currentTarget.id == "ActionItemTab") {
                $('#ActionItemTab1').addClass('active');
                ActionTrackingVM.ActionItemVisible(true);
                GetAllActionItems();
                GetATMetrics();
            }
            else {
                $('#ActionPlanTab1').addClass('active');
                ActionTrackingVM.ActionItemVisible(false);
                GetAllActionPlans();
                GetPlanATMetrics();
            }

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | attached() in ActionTracking.js';
            logger.logMessage(msg);
        }
    }

    function HideallDivs() {
        try {

            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                $('#piechartsonlick' + ActionTrackingVM.ATMetricsList()[i].PROCESS_ID()).hide();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HideallDivs() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }

    function HideallDivsPlan() {
        try {

            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                $('#Planpiechartsonlick' + ActionTrackingVM.ATMetricsList()[i].PROCESS_ID()).hide();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HideallDivsPlan() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }

    function DisplaySelectedDivs() {
        try {
            for (var i = 0; i < ActionTrackingVM.ClickedSurveyPoints().length; i++) {
                $('#piechartsonlick' + ActionTrackingVM.ClickedSurveyPoints()[i]).show();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DisplaySelectedDivs() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }
    function DisplaySelectedDivsPlan() {
        try {
            for (var i = 0; i < ActionTrackingVM.ClickedSurveyPoints().length; i++) {
                $('#Planpiechartsonlick' + ActionTrackingVM.ClickedSurveyPoints()[i]).show();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DisplaySelectedDivsPlan() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }
    function DrawDonutChart()
    {
        try {
            BindDynamicHtmlForPieChart();
            DrawPieChart();
            var donutData = genData();
            var donuts = new DonutCharts(donutData);
            donuts.create(donutData);
            AddclassForDesign();
        }
        catch (e)
        {

        }
    }
    function DrawDonutChartPlan() {
        try {
            BindDynamicHtmlForPieChartPlan();
            DrawPieChartPlan();
            var donutData = genData();
            var donuts = new DonutChartsPlan(donutData);
            donuts.createPlan(donutData);
            AddclassForDesignPlan();
        }
        catch (e) {

        }
    }
    function AddclassForDesign() {
        try {
            $('#donut-charts').addClass('col-lg-3 ')
            $('#donut-charts').addClass('piechartwidth')

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddclassForDesign() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }
    function AddclassForDesignPlan() {
        try {
            $('#Plandonut-charts').addClass('col-lg-3 ')
            $('#Plandonut-charts').addClass('piechartwidth')

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddclassForDesignPlan() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }



    function DownloadActionItemStatus()
    {
        try {
            var payLoad = {
                t: appsecurity.getAuthenticationInfo()

            };
            utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelActionItemsList", payLoad, '_blank');
        }
        catch (e)
        {
            var msg = 'Exception: ' + e + ' | Source: DownloadActionItemStatus() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }
    function DownloadActionDetail(data,event)

    {
        try {
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), AIMID: data.AIM_UID()

            };
            utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelActionItemsDetails", payLoad, '_blank');
        }
        catch (e)
        {
            var msg = 'Exception: ' + e + ' | Source: DownloadActionDetail() method in SurveyTracking.js';
            logger.logMessage(msg);
        }

    }
    function genData() {
        ActionTrackingVM.ATMetricsList();
        var type = [ActionTrackingVM.ATMetricsList()[0].PROCESS_POINT()];
        var unit = [''];
        var cat = [];
        var data = new Array();
        for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
            cat.push(ActionTrackingVM.ATMetricsList()[i].PROCESS_POINT())
        }
        var dataset = new Array();
        for (var j = 1; j <= cat.length; j++) {
            var value = parseInt(ActionTrackingVM.ATMetricsList()[j].COUNT());
            var Id = parseInt(ActionTrackingVM.ATMetricsList()[j].PROCESS_ID());
            var COLOR = ActionTrackingVM.ATMetricsList()[j].COLORCODE();
            if (value != 0) {
                data.push({
                    "cat": cat[j - 1],
                    "val": value,
                    "ID": Id,
                    "COLOR": COLOR
                });
            }

        }

        dataset.push({
            "type": type[0],
            "unit": unit[0],
            "data": data,
            "total": parseInt(ActionTrackingVM.ATMetricsList()[0].COUNT())
        });
        return dataset;
    }


      //function to draw a donut chart starts here
    function DonutCharts(dataset) {

        var charts = d3.select('#donut-charts');


        //div.style("display", "inline-block");
        var chart_m,
            chart_r;
        var div;
        var color = [];
        for (var i = 0; i < dataset[0].data.length; i++) {
            color.push(dataset[0].data[i].COLOR)
        }


        var getCatNames = function (dataset) {
            var catNames = new Array();

            for (var i = 0; i < dataset[0].data.length; i++) {
                catNames.push(dataset[0].data[i].cat);
            }

            return catNames;
        }
        var createCenter = function (pie) {

            var eventObj = {
                'mouseover': function (d, i) {
                    d3.select(this)
                        .transition()
                        .attr("r", chart_r * 0.65);
                },

                'mouseout': function (d, i) {
                    d3.select(this)
                        .transition()
                        .duration(500)
                        .ease('bounce')
                        .attr("r", chart_r * 0.6);
                },

                'click': function (d, i) {
                    var paths = charts.selectAll('.clicked');
                    pathAnim(paths, 0);
                    paths.classed('clicked', false);
                    resetAllCenterText();
                    ActionTrackingVM.ClickedSurveyPoints([]);
                    HideallDivs();
                    DisplaySelectedDivs();
                }
            }

            var donuts = d3.selectAll('.donut');

            // The circle displaying total data.
            donuts.append("svg:circle")
                .attr("r", chart_r * 0.6)
                .style("fill", "#E7E7E7")
                .on(eventObj);

            donuts.append('text')
                .attr('class', 'center-txt type')
                .attr('y', chart_r * -0.16)
                .attr('text-anchor', 'middle')
                .style('font-weight', 'bold')
                .text(function (d, i) {
                    return d.type;
                });
            donuts.append('text')
                .attr('class', 'center-txt value')
                .attr('text-anchor', 'middle');
            donuts.append('text')
                .attr('class', 'center-txt percentage')
                .attr('y', chart_r * 0.16)
                .attr('text-anchor', 'middle')
                .style('fill', '#A2A2A2');
        }

        var setCenterText = function (thisDonut) {

            var sum = d3.sum(thisDonut.selectAll('.clicked').data(), function (d) {
                return d.data.val;
            });

            thisDonut.select('.value')
                .text(function (d) {
                    return (sum) ? sum.toFixed(0) + d.unit
                        : d.total.toFixed(0) + d.unit;
                });
            thisDonut.select('.percentage')
                .text(function (d) {
                    return (sum) ? (sum / d.total * 100).toFixed(2) + '%'
                        : '';
                });
        }

        var resetAllCenterText = function () {
            charts.selectAll('.value')
                .text(function (d) {
                    return d.total.toFixed(0) + d.unit;
                });
            charts.selectAll('.percentage')
                .text('');
        }

        var pathAnim = function (path, dir) {
            switch (dir) {
                case 0:
                    path.transition()
                        .duration(500)
                        .ease('bounce')
                        .attr('d', d3.svg.arc()
                            .innerRadius(chart_r * 0.7)
                            .outerRadius(chart_r)
                        );
                    break;

                case 1:
                    path.transition()
                        .attr('d', d3.svg.arc()
                            .innerRadius(chart_r * 0.7)
                            .outerRadius(chart_r * 1.2)
                        );
                    break;
            }
        }

        var updateDonut = function () {

            var eventObj = {
                'mouseover': function (d, i, j) {
                    div.style("display", "none");
                    pathAnim(d3.select(this), 1);
                    var thisDonut = charts.select('.type' + j);
                    thisDonut.select('.value').text(function (donut_d) {
                        return d.data.val.toFixed(0) + donut_d.unit;
                    });
                    thisDonut.select('.percentage').text(function (donut_d) {
                        return (d.data.val / donut_d.total * 100).toFixed(2) + '%';
                    });

                },

                'mouseout': function (d, i, j) {

                    var thisPath = d3.select(this);
                    div.style("display", "none");
                    if (!thisPath.classed('clicked')) {
                        pathAnim(thisPath, 0);
                    }
                    var thisDonut = charts.select('.type' + j);

                    setCenterText(thisDonut);
                },

                'click': function (d, i, j) {
                    var thisDonut = charts.select('.type' + j);

                    if (0 === thisDonut.selectAll('.clicked')[0].length) {
                        thisDonut.select('circle').on('click')();
                    }

                    var elementpath = d3.select(this);
                    var clicked = elementpath.classed('clicked');
                    if (clicked == false) {


                        var arr = [];
                        arr = ActionTrackingVM.ClickedSurveyPoints();

                        ActionTrackingVM.ClickedSurveyPoints([])
                        if (arr.length < 3) {
                            arr.push(parseInt(d.data.ID));
                            ActionTrackingVM.ClickedSurveyPoints(arr);
                        }
                        else if (arr.length == 3) {
                            var popedelement = arr.shift();
                            var thisPath = d3.select($('#' + popedelement)[0]);
                            var clicked = thisPath.classed('clicked');
                            pathAnim(thisPath, ~~(!clicked));
                            thisPath.classed('clicked', !clicked);

                            setCenterText(thisDonut);
                            arr.push(parseInt(d.data.ID));
                            ActionTrackingVM.ClickedSurveyPoints(arr);
                        }
                    }
                    else {
                        var array = [];
                        array = ActionTrackingVM.ClickedSurveyPoints();

                        ActionTrackingVM.ClickedSurveyPoints([]);
                        var index = array.indexOf(d.data.ID);
                        if (index > -1) {
                            array.splice(index, 1);
                        }
                        ActionTrackingVM.ClickedSurveyPoints(array);
                    }
                    var thisPath = d3.select(this);
                    var clicked = thisPath.classed('clicked');
                    pathAnim(thisPath, ~~(!clicked));
                    thisPath.classed('clicked', !clicked);
                    setCenterText(thisDonut);
                    HideallDivs();
                    DisplaySelectedDivs();
                }
            };

            var pie = d3.layout.pie()
                .sort(null)
                .value(function (d) {
                    return d.val;
                });

            var arc = d3.svg.arc()
                .innerRadius(chart_r * 0.7)
                .outerRadius(function () {
                    return (d3.select(this).classed('clicked')) ? chart_r * 1.2
                        : chart_r;
                });

            // Start joining data with paths
            var paths = charts.selectAll('.donut')
                .selectAll('path')
                .data(function (d, i) {
                    return pie(d.data);
                });

            paths
                .transition()
                .duration(1000)
                .attr('d', arc);

            paths.enter()
                .append('svg:path')
                .attr('d', arc)
                .attr('id', function (d, i) { return d.data.ID })
                .style('fill', function (d, i) {
                    return color[i];
                })
                .style('stroke', '#FFFFFF')
                .on(eventObj)
                .on("mousemove", function (d, i, j) {
                    var x = parseInt(d3.event.pageX);
                    var y = parseInt(d3.event.pageY);
                    div.style("left", x - 20 + "px");
                    div.style("top", y - 250 + "px");
                    div.html((d.data.cat));
                    div.style("display", "block");

                })

            paths.exit().remove();

            resetAllCenterText();
        }

        //tooltip starts here

        //tooltip ends here
        var Selected4arcs = function (dataset) {

            var i = 0;
            var pie = d3.layout.pie()
                .sort(null)
                .value(function (d) {
                    return d.val;
                });
            var paths = charts.selectAll('.donut')
                .selectAll('path')
                .data(function (d, i) {
                    return pie(d.data);
                });
            var thisDonut = charts.select('.type0');

            if (0 === thisDonut.selectAll('.clicked')[0].length) {
                thisDonut.select('circle').on('click')();
            }
            var arr;
            arr = [];
            arr = ActionTrackingVM.ClickedSurveyPoints();
            ActionTrackingVM.ClickedSurveyPoints([])

            for (var i = 0; i <= dataset[0].data.length && i < 3; i++) {
                arr.push(parseInt(dataset[0].data[i].ID));
                var thisPath = d3.select($('#' + dataset[0].data[i].ID)[0]);
                var clicked = thisPath.classed('clicked');
                pathAnim(thisPath, ~~(!clicked));
                thisPath.classed('clicked', !clicked);
                setCenterText(thisDonut);
            }
            ActionTrackingVM.ClickedSurveyPoints(arr);
            HideallDivs();
            DisplaySelectedDivs();

        }

        this.create = function (dataset) {

            var $charts = $('#donut-charts');
            chart_m = $charts.innerWidth() / dataset.length / 2 * 0.14;
            chart_r = $charts.innerWidth() / dataset.length / 2 * 0.90;


            var donut = charts.selectAll('.donut')
                .data(dataset)
                .enter().append('svg:svg')
                .attr('width', ($charts.innerWidth() / 1.25))
                .attr('height', (250))
                .attr('class', 'Donutpiechartmaindiv')
                .append('svg:g')
                .attr('class', function (d, i) {
                    return 'donut type' + i;
                })
                .attr('transform', 'translate(' + (150) + ',' + (138) + ')');

            chart_r = chart_r / 2;

            //createLegend(getCatNames(dataset));
            createCenter();

            updateDonut();
            div = d3.select("#donut-charts").append("div").attr("class", "toolTipPiechart");
            div.style("display", "none");
            Selected4arcs(dataset);

        }

        this.update = function (dataset) {
            // Assume no new categ of data enter
            var donut = charts.selectAll(".donut")
                .data(dataset);

            updateDonut();



        }
    }
        //funciton to draw a donut chart ends here
    
        //function to add donut chart for plan
    function DonutChartsPlan(dataset) {

        var charts = d3.select('#Plandonut-charts');


        //div.style("display", "inline-block");
        var chart_m,
            chart_r;
        var div;
        var color = [];
        for (var i = 0; i < dataset[0].data.length; i++) {
            color.push(dataset[0].data[i].COLOR)
        }


        var getCatNamesPlan = function (dataset) {
            var catNames = new Array();

            for (var i = 0; i < dataset[0].data.length; i++) {
                catNames.push(dataset[0].data[i].cat);
            }

            return catNames;
        }
        var createCenterPlan = function (pie) {

            var eventObj = {
                'mouseover': function (d, i) {
                    d3.select(this)
                        .transition()
                        .attr("r", chart_r * 0.65);
                },

                'mouseout': function (d, i) {
                    d3.select(this)
                        .transition()
                        .duration(500)
                        .ease('bounce')
                        .attr("r", chart_r * 0.6);
                },

                'click': function (d, i) {
                    var paths = charts.selectAll('.clicked');
                    pathAnim(paths, 0);
                    paths.classed('clicked', false);
                    resetAllCenterTextPlan();
                    ActionTrackingVM.ClickedSurveyPoints([]);
                    HideallDivsPlan();
                    DisplaySelectedDivsPlan();
                }
            }

            var donuts = d3.selectAll('.donut');

            // The circle displaying total data.
            donuts.append("svg:circle")
                .attr("r", chart_r * 0.6)
                .style("fill", "#E7E7E7")
                .on(eventObj);

            donuts.append('text')
                .attr('class', 'center-txt type')
                .attr('y', chart_r * -0.16)
                .attr('text-anchor', 'middle')
                .style('font-weight', 'bold')
                .text(function (d, i) {
                    return d.type;
                });
            donuts.append('text')
                .attr('class', 'center-txt value')
                .attr('text-anchor', 'middle');
            donuts.append('text')
                .attr('class', 'center-txt percentage')
                .attr('y', chart_r * 0.16)
                .attr('text-anchor', 'middle')
                .style('fill', '#A2A2A2');
        }

        var setCenterTextPlan = function (thisDonut) {

            var sum = d3.sum(thisDonut.selectAll('.clicked').data(), function (d) {
                return d.data.val;
            });

            thisDonut.select('.value')
                .text(function (d) {
                    return (sum) ? sum.toFixed(0) + d.unit
                        : d.total.toFixed(0) + d.unit;
                });
            thisDonut.select('.percentage')
                .text(function (d) {
                    return (sum) ? (sum / d.total * 100).toFixed(2) + '%'
                        : '';
                });
        }

        var resetAllCenterTextPlan = function () {
            charts.selectAll('.value')
                .text(function (d) {
                    return d.total.toFixed(0) + d.unit;
                });
            charts.selectAll('.percentage')
                .text('');
        }

        var pathAnimPlan = function (path, dir) {
            switch (dir) {
                case 0:
                    path.transition()
                        .duration(500)
                        .ease('bounce')
                        .attr('d', d3.svg.arc()
                            .innerRadius(chart_r * 0.7)
                            .outerRadius(chart_r)
                        );
                    break;

                case 1:
                    path.transition()
                        .attr('d', d3.svg.arc()
                            .innerRadius(chart_r * 0.7)
                            .outerRadius(chart_r * 1.2)
                        );
                    break;
            }
        }

        var updateDonutPlan = function () {

            var eventObj = {
                'mouseover': function (d, i, j) {
                    div.style("display", "none");
                    pathAnim(d3.select(this), 1);
                    var thisDonut = charts.select('.type' + j);
                    thisDonut.select('.value').text(function (donut_d) {
                        return d.data.val.toFixed(0) + donut_d.unit;
                    });
                    thisDonut.select('.percentage').text(function (donut_d) {
                        return (d.data.val / donut_d.total * 100).toFixed(2) + '%';
                    });

                },

                'mouseout': function (d, i, j) {

                    var thisPath = d3.select(this);
                    div.style("display", "none");
                    if (!thisPath.classed('clicked')) {
                        pathAnimPlan(thisPath, 0);
                    }
                    var thisDonut = charts.select('.type' + j);

                    setCenterTextPlan(thisDonut);
                },

                'click': function (d, i, j) {
                    var thisDonut = charts.select('.type' + j);

                    if (0 === thisDonut.selectAll('.clicked')[0].length) {
                        thisDonut.select('circle').on('click')();
                    }

                    var elementpath = d3.select(this);
                    var clicked = elementpath.classed('clicked');
                    if (clicked == false) {


                        var arr = [];
                        arr = ActionTrackingVM.ClickedSurveyPoints();

                        ActionTrackingVM.ClickedSurveyPoints([])
                        if (arr.length < 3) {
                            arr.push(parseInt(d.data.ID));
                            ActionTrackingVM.ClickedSurveyPoints(arr);
                        }
                        else if (arr.length == 3) {
                            var popedelement = arr.shift();
                            var thisPath = d3.select($('#' + popedelement)[0]);
                            var clicked = thisPath.classed('clicked');
                            pathAnimPlan(thisPath, ~~(!clicked));
                            thisPath.classed('clicked', !clicked);

                            setCenterTextPlan(thisDonut);
                            arr.push(parseInt(d.data.ID));
                            ActionTrackingVM.ClickedSurveyPoints(arr);
                        }
                    }
                    else {
                        var array = [];
                        array = ActionTrackingVM.ClickedSurveyPoints();

                        ActionTrackingVM.ClickedSurveyPoints([]);
                        var index = array.indexOf(d.data.ID);
                        if (index > -1) {
                            array.splice(index, 1);
                        }
                        ActionTrackingVM.ClickedSurveyPoints(array);
                    }
                    var thisPath = d3.select(this);
                    var clicked = thisPath.classed('clicked');
                    pathAnimPlan(thisPath, ~~(!clicked));
                    thisPath.classed('clicked', !clicked);
                    setCenterTextPlan(thisDonut);
                    HideallDivsPlanPlan();
                    DisplaySelectedDivsPlan();
                }
            };

            var pie = d3.layout.pie()
                .sort(null)
                .value(function (d) {
                    return d.val;
                });

            var arc = d3.svg.arc()
                .innerRadius(chart_r * 0.7)
                .outerRadius(function () {
                    return (d3.select(this).classed('clicked')) ? chart_r * 1.2
                        : chart_r;
                });

            // Start joining data with paths
            var paths = charts.selectAll('.donut')
                .selectAll('path')
                .data(function (d, i) {
                    return pie(d.data);
                });

            paths
                .transition()
                .duration(1000)
                .attr('d', arc);

            paths.enter()
                .append('svg:path')
                .attr('d', arc)
                .attr('id', function (d, i) { return d.data.ID })
                .style('fill', function (d, i) {
                    return color[i];
                })
                .style('stroke', '#FFFFFF')
                .on(eventObj)
                .on("mousemove", function (d, i, j) {
                    var x = parseInt(d3.event.pageX);
                    var y = parseInt(d3.event.pageY);
                    div.style("left", x - 20 + "px");
                    div.style("top", y - 250 + "px");
                    div.html((d.data.cat));
                    div.style("display", "block");

                })

            paths.exit().remove();

            resetAllCenterTextPlan();
        }

        //tooltip starts here

        //tooltip ends here
        var Selected4arcsPlan = function (dataset) {

            var i = 0;
            var pie = d3.layout.pie()
                .sort(null)
                .value(function (d) {
                    return d.val;
                });
            var paths = charts.selectAll('.donut')
                .selectAll('path')
                .data(function (d, i) {
                    return pie(d.data);
                });
            var thisDonut = charts.select('.type0');

            if (0 === thisDonut.selectAll('.clicked')[0].length) {
                thisDonut.select('circle').on('click')();
            }
            var arr;
            arr = [];
            arr = ActionTrackingVM.ClickedSurveyPoints();
            ActionTrackingVM.ClickedSurveyPoints([])

            for (var i = 0; i <= dataset[0].data.length && i < 3; i++) {
                arr.push(parseInt(dataset[0].data[i].ID));
                var thisPath = d3.select($('#' + dataset[0].data[i].ID)[0]);
                var clicked = thisPath.classed('clicked');
                pathAnimPlan(thisPath, ~~(!clicked));
                thisPath.classed('clicked', !clicked);
                setCenterTextPlan(thisDonut);
            }
            ActionTrackingVM.ClickedSurveyPoints(arr);
            HideallDivsPlan();
            DisplaySelectedDivsPlan();

        }

        this.createPlan = function (dataset) {

            var $charts = $('#Plandonut-charts');
            chart_m = $charts.innerWidth() / dataset.length / 2 * 0.14;
            chart_r = $charts.innerWidth() / dataset.length / 2 * 0.90;


            var donut = charts.selectAll('.donut')
                .data(dataset)
                .enter().append('svg:svg')
                .attr('width', ($charts.innerWidth() / 1.25))
                .attr('height', (250))
                .attr('class', 'Donutpiechartmaindiv')
                .append('svg:g')
                .attr('class', function (d, i) {
                    return 'donut type' + i;
                })
                .attr('transform', 'translate(' + (150) + ',' + (138) + ')');

            chart_r = chart_r / 2;

            //createLegend(getCatNames(dataset));
            createCenterPlan();

            updateDonutPlan();
            div = d3.select("#Plandonut-charts").append("div").attr("class", "toolTipPiechart");
            div.style("display", "none");
            Selected4arcsPlan(dataset);

        }

        this.update = function (dataset) {
            // Assume no new categ of data enter
            var donut = charts.selectAll(".donut")
                .data(dataset);

            updateDonutPlan();



        }
    }

        //function to end donut chart creation for plan
    function GetAllActionPlans() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/GetAllActionPlans",
                headers: headers,
                type: "GET",
                applicationType: 'application/json',
                dataType: 'json'
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception' + e + ' || source: ajax call in GetAllActionPlans() in ActionTracking.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                var ActionTrackingData = $.map(jsonResult, function (result) {
                    return new ActionPlanModel(result);
                });
                //RaTableObj.destroy();
                dtable = $("#tblActionPlanTracking").DataTable();
                dtable.destroy();
                $("#tblActionPlanTracking tbody tr").remove();
                ActionTrackingVM.ActionPlanTrackingList([]);
                ActionTrackingVM.ActionPlanTrackingList(ActionTrackingData);
                RaTableObj = $('#tblActionPlanTracking').DataTable({
                    "lengthMenu": [[15, 25, 50, -1], [15, 25, 50, "All"]],
                    "pageLength": 15,
                    responsive: true
                });
                $('#tblActionPlanTracking').dataTable().columnFilter({
                    sPlaceHolder: 'footer:before',
                    aoColumns: [{ type: "select" },
                    { type: "select" },
                    { type: "select" },
                    { type: "select" },
                    { type: "select" },
                    { type: "select" },                   
                    { type: "select" }
                    ]
                });
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source: ajaxSuccess in GetAllActionPlans() in ActionTracking.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in fetching Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' || Source: ajaxFail in GetAllActionPlans() method in ActionTracking.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' || Source: ajaxFail in GetAllActionPlans() method in ActionTracking.js';
                logger.logMessage(msg);
            }
        }
    }


    function GetAllActionItems() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/ActionPlan/GetAllActionItemsForTracking",
                headers: headers,
                type: "GET",
                applicationType: 'application/json',
                dataType: 'json'
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception' + e + ' || source: ajax call in GetAllActionItems() in Surveytracking.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                var ActionTrackingData = $.map(jsonResult, function (result) {
                    return new ActiontrackingModel(result);
                });
                //RaTableObj.destroy();
                $('#LoadingImgMain').hide();
                $('#tblActionTracking').show();
                dtable = $("#tblActionTracking").DataTable();
                dtable.destroy();
                $('#tblActionTracking tbody tr').remove();
                ActionTrackingVM.ActionTrackingList([]);
                ActionTrackingVM.ActionTrackingList(ActionTrackingData);
                RaTableObj = $('#tblActionTracking').DataTable({
                    "lengthMenu": [[15, 25, 50, -1], [15, 25, 50, "All"]],
                    "pageLength": 15,
                     responsive: true
                });
                $('#tblActionTracking').dataTable().columnFilter({
                    sPlaceHolder: 'footer:before',
                    aoColumns: [{ type: "select" },
                    { type: "select" },
                    { type: "select" },
                    { type: "select" },
                    { type: "select" },
                    { type: "select" },
                    { type: "select" },
                    { type: "select" }
                    ]
                });
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source: ajaxSuccess in GetAllActionItems() in ActionTracking.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in fetching Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' || Source: ajaxFail in GetAllActionItems() method in ActionTracking.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' || Source: ajaxFail in GetAllActionItems() method in ActionTracking.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetPlanATMetrics() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetPlanATMetrics",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetPlanATMetrics() method in ActionTracking.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedActionMetrics = $.map(jsonResult, function (result) {
                        return new ATMMetricsModel(result);
                    });
                    ActionTrackingVM.ATMetricsList(mappedActionMetrics);
                    var TotalMetrics = [];
                    for (var i = 0; i < ActionTrackingVM.ATMetricsList().length; i++) {
                        TotalMetrics.push(parseInt(ActionTrackingVM.ATMetricsList()[i].COUNT()));
                    }
                    ActionTrackingVM.OverallMetrics(TotalMetrics);
                    if (ActionTrackingVM.ATMetricsList().length - 1 > 5) {
                        DrawDonutChartPlan();
                    }
                    else {
                        BindDynamicHtmlForPieChartforfewprocesspointsPlan();
                        drawpiechartforfewerprocesspointsPlan();
                    }

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetPlanATMetrics() method in ActionTracking.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in GetPlanATMetrics", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetPlanATMetrics() method in ActionTracking.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetPlanATMetrics() method in ActionTracking.js';
                logger.logMessage(msg);
            }
        };

    }
    function GetATMetrics() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetATMetrics",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetATMetrics() method in ActionTracking.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedActionMetrics = $.map(jsonResult, function (result) {
                        return new ATMMetricsModel(result);
                    });
                    ActionTrackingVM.ATMetricsList(mappedActionMetrics);
                    var TotalMetrics = [];
                    for (var i = 0; i < ActionTrackingVM.ATMetricsList().length; i++) {
                        TotalMetrics.push(parseInt(ActionTrackingVM.ATMetricsList()[i].COUNT()));
                    }
                    ActionTrackingVM.OverallMetrics(TotalMetrics);
                    if (ActionTrackingVM.ATMetricsList().length - 1 > 5)
                    {
                        DrawDonutChart();
                    }
                    else
                    {
                                            BindDynamicHtmlForPieChartforfewprocesspoints();
                    drawpiechartforfewerprocesspoints();
                    }

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetATMetrics() method in ActionTracking.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in GetATMetrics", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetATMetrics() method in ActionTracking.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetATMetrics() method in ActionTracking.js';
                logger.logMessage(msg);
            }
        };

    }

    function BindDynamicHtmlForPieChartforfewprocesspointsPlan() {
        try {
            var DynamicHtml = "";
            DynamicHtml += "<div class='col-lg-10'>";

            DynamicHtml += "<div class='MultiCarousel' data-items='1, 3, 5, 6' data-slide='1' id='MultiCarousel' data-interval='1000'><div class='MultiCarousel-inner'>"

            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                DynamicHtml += "<div class='item'>" +
                    "<div class='pad-15 stats-overview stat-block' style='background-color:" + ActionTrackingVM.ATMetricsList()[i].COLORCODE() + "'>" +

                    "<div id='Planchart" + i + "'>" +
                    "</div>" +
                    " </div>" +
                    `<div class="state-lbl headcoltest" id="headcoltest_` + i + `"type='button'> <span class='state-number'>` + ActionTrackingVM.ATMetricsList()[i].COUNT() + `</span>` + ActionTrackingVM.ATMetricsList()[i].PROCESS_POINT() + `</div>` +

                    " </div>";
                 
            }
            DynamicHtml += "</div>"
            DynamicHtml += "<span class='leftLst'><i class='demo-icon icon-simple_arrow_left_special'></i> </span><span class='rightLst'><i class='demo-icon icon-simple_arrow_right_special'></i></span>"
            DynamicHtml += "</div></div>"

            DynamicHtml += "<div class='col-lg-2'>";
            DynamicHtml += "<div class='stats-overview stat-block totalSurvey'>" +
                " <div class='details'>" +
                "<div class='numbers' style='margin-top: 2.5em;margin-left: 2.5em;'>" +
                "<label> " + ActionTrackingVM.ATMetricsList()[0].PROCESS_POINT().replace("Action Plan -", "") + " : " + ActionTrackingVM.ATMetricsList()[0].COUNT() + "</label>" +
                "</div>" +
                "</div>" +
                " </div>" +
                "</div>";
            document.getElementById('PlandivDashboard').innerHTML = DynamicHtml;
            applySrollableComponent();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:BindDynamicHtmlForPieChartforfewprocesspointsPlan() method in ActionTracking.js';
            logger.logMessage(msg);
        }
        }
        //function BindDynamicHtmlForPieChartforfewprocesspoints() {
        //    try {
        //        var DynamicHtml = "";

        //        DynamicHtml += "<div class='col-lg-10'>";

        //        DynamicHtml += "<div class='MultiCarousel' data-items='1, 3, 5, 6' data-slide='1' id='MultiCarousel' data-interval='1000'><div class='MultiCarousel-inner'>"
        //        for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
        //            DynamicHtml += "<div class='item'>" +
        //                "<div class='pad-15 stats-overview stat-block' style='background-color:" + ActionTrackingVM.ATMetricsList()[i].COLORCODE() + "'>" +
        //                "   <div id='chart" + i + "'>" +

        //                "</div>" +
        //                " </div>" +
        //                //" <div class='state-lbl headcoltest' data-bind='click: $root.FiltersForGraphs' type='button'> <span class='state-number'>" + SurveyTrackingVM.SurveyProcessPointsList()[i].COUNT() + "</span>" + SurveyTrackingVM.SurveyProcessPointsList()[i].PROCESS_POINT() + "</div>" +

        //                `<div class="state-lbl headcoltest" id="headcoltest_` + i + `" data-bind="click: function (data, event) { $root.FiltersForGraphs(` + ActionTrackingVM.ATMetricsList()[i].PROCESS_ID() + `)}" type='button'> <span class='state-number'>` + ActionTrackingVM.ATMetricsList()[i].COUNT() + `</span>` + ActionTrackingVM.ATMetricsList()[i].PROCESS_POINT() + `</div>` +

        //                "</div>";
        //        }

        //        DynamicHtml += "</div>"
        //        DynamicHtml += "<span class='leftLst'><i class='demo-icon icon-simple_arrow_left_special'></i> </span><span class='rightLst'><i class='demo-icon icon-simple_arrow_right_special'></i></span>"
        //        DynamicHtml += "</div></div>"

        //        DynamicHtml += "<div class='col-lg-2'>";

        //        DynamicHtml += '<div class="total" id="TotalST" type="button" data-bind="click: $root.ClearAllBuFilters"><div class="stats-overview stat-block totalSurvey">' +
        //            " <div class='details'>" +
        //            "<div class='numbers'" +
        //            "<label>" + ActionTrackingVM.ATMetricsList()()[0].PROCESS_POINT() + "</label><span class='scount'>" + ActionTrackingVM.ATMetricsList()()[0].COUNT() + "</span>" +
        //            "</div>" +
        //            "</div>" +
        //            " </div>" +
        //            "</div> </div>";

        //        document.getElementById('divDashboard').innerHTML = DynamicHtml;
        //        ko.applyBindingsToNode($('#TotalST'), { click: SurveyTrackingVM.ClearAllBuFilters }, SurveyTrackingVM);


        //        //for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
        //        //    ko.applyBindingsToNode($('#headcoltest_' + i), { click: SurveyTrackingVM.FiltersForGraphs }, ActionTrackingVM.ATMetricsList()[i].PROCESS_ID());
        //        //}
        //        applySrollableComponent();
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source:BindDynamicHtmlForPieChartforfewprocesspoints() method in SurveyTracking.js';
        //        logger.logMessage(msg);
        //    }
        //}

        function applySrollableComponent() {
            var itemsMainDiv = ('.MultiCarousel');
            var itemsDiv = ('.MultiCarousel-inner');
            var itemWidth = "";

            $('.leftLst, .rightLst').click(function () {
                var condition = $(this).hasClass("leftLst");
                if (condition)
                    click(0, this);
                else
                    click(1, this)
            });

            ResCarouselSize();

            $(window).resize(function () {
                ResCarouselSize();
            });

            //this function define the size of the items
            function ResCarouselSize() {
                var incno = 0;
                var dataItems = ("data-items");
                var itemClass = ('.item');
                var id = 0;
                var btnParentSb = '';
                var itemsSplit = '';
                var sampwidth = $(itemsMainDiv).width();
                var bodyWidth = $('body').width();
                $(itemsDiv).each(function () {
                    id = id + 1;
                    var itemNumbers = $(this).find(itemClass).length;
                    btnParentSb = $(this).parent().attr(dataItems);
                    itemsSplit = btnParentSb.split(',');
                    $(this).parent().attr("id", "MultiCarousel" + id);


                    if (bodyWidth >= 900) {
                        incno = itemsSplit[1];
                        itemWidth = sampwidth / incno;
                    }
                    else if (bodyWidth >= 900) {
                        incno = itemsSplit[1];
                        itemWidth = sampwidth / incno;
                    }

                    $(this).css({ 'transform': 'translateX(0px)', 'width': itemWidth * itemNumbers });
                    $(this).find(itemClass).each(function () {
                        $(this).outerWidth(itemWidth);
                    });

                    $(".leftLst").addClass("over");
                    $(".rightLst").removeClass("over");

                });
            }


            //this function used to move the items
            function ResCarousel(e, el, s) {
                var leftBtn = ('.leftLst');
                var rightBtn = ('.rightLst');
                var translateXval = '';
                var divStyle = $(el + ' ' + itemsDiv).css('transform');
                var values = divStyle.match(/-?[\d\.]+/g);
                var xds = Math.abs(values[4]);
                if (e == 0) {
                    translateXval = parseInt(xds) - parseInt(itemWidth * s);
                    $(el + ' ' + rightBtn).removeClass("over");

                    if (translateXval <= itemWidth / 2) {
                        translateXval = 0;
                        $(el + ' ' + leftBtn).addClass("over");
                    }
                }
                else if (e == 1) {
                    var itemsCondition = $(el).find(itemsDiv).width() - $(el).width();
                    translateXval = parseInt(xds) + parseInt(itemWidth * s);
                    $(el + ' ' + leftBtn).removeClass("over");

                    if (translateXval >= itemsCondition - itemWidth / 2) {
                        translateXval = itemsCondition;
                        $(el + ' ' + rightBtn).addClass("over");
                    }
                }
                $(el + ' ' + itemsDiv).css('transform', 'translateX(' + -translateXval + 'px)');
            }

            //It is used to get some elements from btn
            function click(ell, ee) {
                var Parent = "#" + $(ee).parent().attr("id");
                var slide = $(Parent).attr("data-slide");
                ResCarousel(ell, Parent, slide);
            }
        }
    function BindDynamicHtmlForPieChartforfewprocesspoints() {
        try {
            var DynamicHtml = "";
            //if (ActionTrackingVM.ATMetricsList().length == 4) {
            //    DynamicHtml = "<div class='col-xs-2 col-sm-2 col-md-2 col-lg-2 col-lg-offset-1'>";
            //}
            //else {
            //    DynamicHtml = "<div class='col-xs-2 col-sm-2 col-md-2 col-lg-2'>";
            //}
          

            DynamicHtml += "<div class='col-lg-10'>";

            DynamicHtml += "<div class='MultiCarousel' data-items='1, 3, 5, 6' data-slide='1' id='MultiCarousel' data-interval='1000'><div class='MultiCarousel-inner d-flex'>"
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                DynamicHtml += "<div class='item'>" +
                                "<div class='pad-15 stats-overview stat-block' style='background-color:" + ActionTrackingVM.ATMetricsList()[i].COLORCODE() + "'>" +
                               
                               "<div id='chart" + i + "'>" +
                    "</div>" +
                    " </div>" +
                    `<div class="state-lbl headcoltest" id="headcoltest_` + i + `"type='button'> <span class='state-number'>` + ActionTrackingVM.ATMetricsList()[i].COUNT() + `</span>` + ActionTrackingVM.ATMetricsList()[i].PROCESS_POINT() + `</div>` +                              
                                "</div>";
            }
            DynamicHtml += "</div>"
            DynamicHtml += "<span class='leftLst'><i class='demo-icon icon-simple_arrow_left_special'></i> </span><span class='rightLst'><i class='demo-icon icon-simple_arrow_right_special'></i></span>"
            DynamicHtml += "</div></div>"


            DynamicHtml += "<div class='col-lg-2'>";
            DynamicHtml += "<div class='stats-overview stat-block totalSurvey'>" +
                " <div class='details'>" +
                "<div class='numbers' style='margin-top: 2.5em;margin-left: 2.5em;'>" +
                "<label> " + ActionTrackingVM.ATMetricsList()[0].PROCESS_POINT().replace("Action Item -", "") + " : " + ActionTrackingVM.ATMetricsList()[0].COUNT() + "</label>" +
                "</div>" +
                "</div>" +
                " </div>" +
                "</div>";
            document.getElementById('divDashboard').innerHTML = DynamicHtml;
            applySrollableComponent();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:BindDynamicHtmlForPieChartforfewprocesspoints() method in ActionTracking.js';
            logger.logMessage(msg);
        }
    }
    function BindDynamicHtmlForPieChart() {
        try {

            var DynamicHtml = "";
            DynamicHtml = "<div class='col-xs-2 col-sm-2 col-md-2 col-lg-2 col-lg-offset-0point5' style='margin-top:9vh'>" +
                "<div class='stats-overview stat-block totalSurvey'>" +
                " <div class='details'>" +
                "<div class='numbers' style='margin-top: 2.5em;margin-left: 2.5em;'>" +
                "<label>" + ActionTrackingVM.ATMetricsList()[0].PROCESS_POINT() + " : " + ActionTrackingVM.ATMetricsList()[0].COUNT() + "</label>" +
                "</div>" +
                "</div>" +
                " </div>" +
                "</div>";
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                DynamicHtml += "<div id=piechartsonlick" + ActionTrackingVM.ATMetricsList()[i].PROCESS_ID() + " class='col-xs-2 col-sm-2 col-md-2 col-lg-2' style='margin-top:9vh'>" +
                    "<div class='stats-overview stat-block' style='background-color:" + ActionTrackingVM.ATMetricsList()[i].COLORCODE() + "'>" +
                    "   <div id='chart" + i + "'>" +

                    "</div>" +
                    " <label class='title'>" + ActionTrackingVM.ATMetricsList()[i].PROCESS_POINT() + " : " + ActionTrackingVM.ATMetricsList()[i].COUNT() + "</label>" +
                    " </div>" +
                    "</div>";
            }
            document.getElementById('speedometer').innerHTML = DynamicHtml;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:BindDynamicHtmlForPieChart() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }
    function BindDynamicHtmlForPieChartPlan() {
        try {

            var DynamicHtml = "";
            DynamicHtml = "<div class='col-xs-2 col-sm-2 col-md-2 col-lg-2 col-lg-offset-0point5' style='margin-top:9vh'>" +
                "<div class='stats-overview stat-block totalSurvey'>" +
                " <div class='details'>" +
                "<div class='numbers' style='margin-top: 2.5em;margin-left: 2.5em;'>" +
                "<label>" + ActionTrackingVM.ATMetricsList()[0].PROCESS_POINT() + " : " + ActionTrackingVM.ATMetricsList()[0].COUNT() + "</label>" +
                "</div>" +
                "</div>" +
                " </div>" +
                "</div>";
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                DynamicHtml += "<div id=Planpiechartsonlick" + ActionTrackingVM.ATMetricsList()[i].PROCESS_ID() + " class='col-xs-2 col-sm-2 col-md-2 col-lg-2' style='margin-top:9vh'>" +
                    "<div class='stats-overview stat-block' style='background-color:" + ActionTrackingVM.ATMetricsList()[i].COLORCODE() + "'>" +
                    "   <div id='Planchart" + i + "'>" +

                    "</div>" +
                    " <label class='title'>" + ActionTrackingVM.ATMetricsList()[i].PROCESS_POINT() + " : " + ActionTrackingVM.ATMetricsList()[i].COUNT() + "</label>" +
                    " </div>" +
                    "</div>";
            }
            document.getElementById('Planspeedometer').innerHTML = DynamicHtml;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:BindDynamicHtmlForPieChartPlan() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }

    function drawpiechartforfewerprocesspoints() {
        try {
            var sum = 0;
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                var percent = parseInt(Math.round((ActionTrackingVM.OverallMetrics()[i] / ActionTrackingVM.OverallMetrics()[0]) * 100));
                if (isNaN(percent)) {
                    percent = '-';
                }
                sum = sum + percent;
                var chartbody = '<span id=piechart' + i + ' class="chart" data-percent="' + percent + '">' +
    ' <span class="percent">' + percent + '</span></span>';
                document.getElementById('chart' + i).innerHTML = chartbody;

            }
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                $(function () {
                    $('#piechart' + i).easyPieChart({
                        barColor: '#ffffff',
                        trackColor: 'rgba(255,255,255,0.3)',
                        easing: 'easeOutBounce'
                    });
                    var chart = window.chart = $('#chart' + i).data('easyPieChart');
                });
            }
            var diff = sum - 100;
            for (var i = ActionTrackingVM.ATMetricsList().length.length - 1; i >= 1; i--) {
                if (parseInt($('#piechart' + i + ' span').text()) != 0 && parseInt($('#piechart' + i + ' span').text()) > diff) {
                    var textvalue = parseInt($('#piechart' + i + ' span').text())
                    $('#piechart' + i + ' span').text(textvalue - diff);
                    break;
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: drawpiechartforfewerprocesspoints() method in ActionTracking.js';
            logger.logMessage(msg);
        }
    }
    function drawpiechartforfewerprocesspointsPlan() {
        try {
            var sum = 0;
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                var percent = parseInt(Math.round((ActionTrackingVM.OverallMetrics()[i] / ActionTrackingVM.OverallMetrics()[0]) * 100));
                if (isNaN(percent)) {
                    percent = '-';
                }
                sum = sum + percent;
                var chartbody = '<span id=Planpiechart' + i + ' class="chart" data-percent="' + percent + '">' +
                    ' <span class="percent">' + percent + '</span></span>';
                document.getElementById('Planchart' + i).innerHTML = chartbody;

            }
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                $(function () {
                    $('#Planpiechart' + i).easyPieChart({
                        barColor: '#ffffff',
                        trackColor: 'rgba(255,255,255,0.3)',
                        easing: 'easeOutBounce'
                    });
                    var chart = window.chart = $('#Planchart' + i).data('easyPieChart');
                });
            }
            var diff = sum - 100;
            for (var i = ActionTrackingVM.ATMetricsList().length.length - 1; i >= 1; i--) {
                if (parseInt($('#Planpiechart' + i + ' span').text()) != 0 && parseInt($('#Planpiechart' + i + ' span').text()) > diff) {
                    var textvalue = parseInt($('#Planpiechart' + i + ' span').text())
                    $('#Planpiechart' + i + ' span').text(textvalue - diff);
                    break;
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: drawpiechartforfewerprocesspointsPlan() method in ActionTracking.js';
            logger.logMessage(msg);
        }
    }

    function DrawPieChart() {
        try {
            HideallDivs();
            DisplaySelectedDivs();
            var sum = 0;
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                var percent = parseInt(Math.round((ActionTrackingVM.OverallMetrics()[i] / ActionTrackingVM.OverallMetrics()[0]) * 100));
                if (isNaN(percent)) {
                    percent = '-';
                }
                sum = sum + percent;
                var chartbody = '<span id=piechart' + i + ' class="chart" data-percent="' + percent + '">' +
                    ' <span class="percent">' + percent + '</span></span>';
                document.getElementById('chart' + i).innerHTML = chartbody;

            }
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                $(function () {
                    $('#piechart' + i).easyPieChart({
                        barColor: '#ffffff',
                        trackColor: 'rgba(255,255,255,0.3)',
                        easing: 'easeOutBounce'
                    });
                    var chart = window.chart = $('#chart' + i).data('easyPieChart');
                });
            }
            var diff = sum - 100;
            for (var i = ActionTrackingVM.ATMetricsList().length - 1; i >= 1; i--) {
                if (parseInt($('#piechart' + i + ' span').text()) != 0 && parseInt($('#piechart' + i + ' span').text()) > diff) {
                    var textvalue = parseInt($('#piechart' + i + ' span').text())
                    $('#piechart' + i + ' span').text(textvalue - diff);
                    break;
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DrawPieChart() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }
    function DrawPieChartPlan() {
        try {
            HideallDivsPlan();
            DisplaySelectedDivsPlan();
            var sum = 0;
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                var percent = parseInt(Math.round((ActionTrackingVM.OverallMetrics()[i] / ActionTrackingVM.OverallMetrics()[0]) * 100));
                if (isNaN(percent)) {
                    percent = '-';
                }
                sum = sum + percent;
                var chartbody = '<span id=Planpiechart' + i + ' class="chart" data-percent="' + percent + '">' +
                    ' <span class="percent">' + percent + '</span></span>';
                document.getElementById('chart' + i).innerHTML = chartbody;

            }
            for (var i = 1; i < ActionTrackingVM.ATMetricsList().length; i++) {
                $(function () {
                    $('#piechart' + i).easyPieChart({
                        barColor: '#ffffff',
                        trackColor: 'rgba(255,255,255,0.3)',
                        easing: 'easeOutBounce'
                    });
                    var chart = window.chart = $('#Planchart' + i).data('easyPieChart');
                });
            }
            var diff = sum - 100;
            for (var i = ActionTrackingVM.ATMetricsList().length - 1; i >= 1; i--) {
                if (parseInt($('#Planpiechart' + i + ' span').text()) != 0 && parseInt($('#Planpiechart' + i + ' span').text()) > diff) {
                    var textvalue = parseInt($('#Planpiechart' + i + ' span').text())
                    $('#Planpiechart' + i + ' span').text(textvalue - diff);
                    break;
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DrawPieChartPlan() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }

    function ViewActionItemDetails(data, event) {
        try {
            var AIMUID;
            var AIMName;
            if (data.AIM_UID.length == undefined) {
                AIMUID = data.AIM_UID;
                AIMName = data.AIM_Display_ID;
            }
            else {
                AIMUID = data.AIM_UID();
                AIMName = data.AIM_Display_ID();
            }
            ActionTrackingVM.ResponseMoveArray(new ResponseMoveModel({ ActionItemId: AIMUID, ActionItemNumber: AIMName,  RoleName: '', ActionItemStatus: '', RoleId: '', CompletedFlag: 1, IsComposeFlag: ko.observable(0) }));
            ActionTrackingVM.appsecurity.ActionFlagType("Item");
            router.navigate("#ActionTracker/ActionItemDetails", true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ViewActionItemDetails() method in ActionTracking.js';
            logger.logMessage(msg);
        }
    }

    function SendActionItemNotification(data, event) {
        try {
            app.showMessage('Do you want to send an e-mail reminder notification to this Action Itme Owner/Reviewer?', 'Send e-mail reminder notification', ['Send', 'Cancel'])
                   .then(function (option) {
                       if (option === 'Send') {
                           SendEmailtoValidRecepients(data.Pending_At(), data.PendingatEmail(), data.AIM_Display_ID());
                           logger.logSuccess('E-mail reminder notification sent out successfully.', 'Success', system.getModuleId(ActionTrackingVM), true);
                       }
                   });
        }
        catch (e) {
            var msg = 'Exception' + e + ' || Source: aajx call in SendActionItemNotification() in ActionTracking.js';
            logger.logMessage(msg)
        }
    }


        function SendEmailtoValidRecepients(List, Email, AIM_Display_ID)
{
    try {
        var csrfToken = $("input[name='__RequestVerificationToken']").val();
        var headers = appsecurity.getSecurityHeaders();
        headers.__RequestVerificationToken = csrfToken;
   return $.ajax({
                url: "/api/ActionPlan/SendEmailtoValidRecepients",
                type: "POST",
                headers: headers,
                data: { Pending_At: List, PendingatEmail: Email, AIM_UID_LABEL: AIM_Display_ID}
            })
       .success(function (Jsonresult, error) {

})
                .fail(function(error,fail){

})
}
catch(e)
{
            var msg = 'Exception' + e + ' || Source:  SendEmailtoValidRecepients() in ActionTracking.js';
            logger.logMessage(msg)
}
}
    function ActionSummaryModel(item) {
        try {
            var self = this;
            self.WPP_UID = ko.observable($('<div/>').html(item.WPP_UID).text());
            self.COUNT = ko.observable($('<div/>').html(item.COUNT).text());
            self.STATUS = ko.observable(item.STATUS);
            self.WPP_NAME = ko.observable(item.WPP_NAME);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionSummaryModel() method in ActionTracking.js';
            logger.logMessage(msg);
        }
    }

    function ActionPlanModel(item) {
        try {
            var self = this;
            self.IS_SELECTED = ko.observable(false);
            self.ActionPlanId = ko.observable($('<div/>').html(item.ActionPlanId).text());
            self.ActionPlanTitle = ko.observable($('<div/>').html(item.ActionPlanTitle).text());
            self.ActionPlanLabel = ko.observable($('<div/>').html(item.ActionPlanLabel).text());
            self.PlanOwner = ko.observable($('<div/>').html(item.PlanOwner).text());
            self.PlanReviewer = ko.observable($('<div/>').html(item.PlanReviewer).text());
            self.CreatedByUser = ko.observable($('<div/>').html(item.CreatedByUser).text());
            self.ActionPlanPriority = ko.observable($('<div/>').html(item.ActionPlanPriority).text());
            self.colorcode = ko.observable($('<div/>').html(item.workflowColor).text());
            self.Status = ko.observable($('<div/>').html(item.Status).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionPlanModel() method in ActionPlanManagement.js';
            logger.logMessage(msg);
        }
    }

    function ActiontrackingModel(item) {
        try {
            var self = this;
            self.AIM_UID = ko.observable($('<div/>').html(item.AIM_UID).text());
            self.AIM_Display_ID = ko.observable(item.AIM_UID_LABEL);
            self.Action_Title = ko.observable(item.AIM_TITLE);
            self.BU_NAME = ko.observable(item.BU_NAME);
            self.Assessment_Period = ko.observable(item.ASSESSMENT_PROFILE);
            self.Assessment_Type = ko.observable(item.RAT_ASSESSMENT_TYPE);
            self.Pending_At = ko.observable(item.Pending_At);
            self.PendingatEmail = ko.observable(item.PendingatEmail);
            self.Status = ko.observable(item.Status);
            if (self.Status().includes('completed')) {
                self.Aging = ko.observable($('<div/>').html(item.Status).text());
            }
            else {
                self.Aging = ko.observable($('<div/>').html(item.Aging).text() + ' day(s)');
            }
            self.COLORCODE = ko.observable($('<div/>').html(item.COLORCODE).text());
            self.StatusCode = ko.observable($('<div/>').html(item.AIM_STATUS_COLOR).text());
            self.IsComplete = ko.observable(item.IsComplete);
            self.AIM_STATUS = ko.observable(item.AIM_STATUS);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActiontrackingModel() method in ActionTracking.js';
            logger.logMessage(msg);
        }
    }
    function ATMMetricsModel(item) {
        try {
            var self = this;
            self.PROCESS_ID = ko.observable($('<div/>').html(item.PROCESS_ID).text());
            self.PROCESS_POINT = ko.observable($('<div/>').html(item.PPDISPNAME).text());
            self.COUNT = ko.observable($('<div/>').html(item.COUNT).text());
            self.COLORCODE = ko.observable($('<div/>').html(item.COLORCODE).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ATMMetricsModel() method in ActionTracking.js';
            logger.logMessage(msg);
        }
    }
    function ResponseMoveModel(item) {
        try {
            var self = this;
            self.ActionItemId = ko.observable(item.ActionItemId);
            self.ActionItemNumber = ko.observable(item.ActionItemNumber);
            self.RoleName = ko.observable(item.RoleName);
            self.RoleId = ko.observable(item.RoleId);
            self.ActionItemStatus = ko.observable(item.ActionItemStatus);
            self.CompletedFlag = ko.observable(item.CompletedFlag);
            self.IsComposeFlag = ko.observable(2);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in ActionTracking.js';
            logger.logMessage(msg);
        }
    }

});
